<div class="content-modal">
      <div class="close-modal">
            <img appImageSelector alt="mt-image" imageType="icon" imageKey="close-gray" (click)="activeModal.close()">
      </div>
      <div class="container-modal">
            <div class="loop">
                  <span class="text-align-center">
                        {{ title }} - {{'shift_'| lang }} {{ shift }}
                  </span>
            </div>

            <div class="date-since">
                  <span>
                        {{ subtitle }} {{ 'hours' | lang | lowercase }}
                  </span>
            </div>


      </div>
      <app-main-table [tableConfig]="tableConfig" class="table-container"></app-main-table>
</div>